<template>
  <div class="template_accueil">
    <AccueilDesktop class="template_accueil__Desktop" id="desktop" />
    <AccueilMobile class="template_accueil__Mobile" />
  </div>
</template>

<script>
import AccueilMobile from '@/components/accueil/AccueilMobile.vue'
import AccueilDesktop from '@/components/accueil/AccueilDesktop.vue'
export default {
  name: 'AccueilView',
  components: {
    AccueilDesktop,
    AccueilMobile
  }
}
</script>

<style lang=scss>
.template_accueil__Desktop {
  display: none;
}
.template_accueil__Mobile {
  display: block;
}
@media screen and (min-width: 1366px) {
  .template_accueil__Desktop {
    display: block;
  }
  .template_accueil__Mobile {
    display: none;
  }
}
</style>
